import React, { useEffect, useMemo, useState } from "react";

// import ContactListItem from "./ContactListItem";
// import MainSidebarMoreMenu from "./MainSidebarMoreMenu";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { Avatar } from "@mui/material";
// import { useAppDispatch, useAppSelector } from "app/store";
// import clsx from "clsx";
// import { motion } from "framer-motion";
// import FuseScrollbars from "@fuse/core/FuseScrollbars";
// import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
// import FuseUtils from "@fuse/utils";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import { lighten } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import API from "../../API";
import { useAppSelector } from "../../Redux/hooks";

import ChatListItem from "./ChatListItem";

/**
 * The main sidebar.
 */
function MainSidebar() {
    const { user, chatNotify } = useAppSelector((state) => state);
    const parameterValues = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    const [chatReciver, setChatReciver] = useState<any>();
    const [chatDealerShip, setChatDealerShip] = useState<any>();
    const uniqueSenderIds = new Set();
    // const uniqueChats = chats?.filter((chat: any) => {
    //     const isDuplicate = uniqueSenderIds.has(chat.Sender_UserId);

    //     uniqueSenderIds.add(chat.Sender_UserId);

    //     return !isDuplicate && chat?.Sender_UserId !== user?.UserID;
    // });
    let notificationForDBS: any;
    if (user?.RoleId === 1 || user?.RoleId === 2) {
        notificationForDBS = chatNotify?.chatObjects
            ?.filter((e: any) => {
                return e?.Sender_UserId !== user?.UserID;
            })
            .sort((a: any, b: any) => b.Chat_ID - a.Chat_ID);
    } else if (Number(parameterValues?.viewChat) === 1) {
        notificationForDBS = chatNotify?.chatObjects
            ?.filter((e: any) => {
                return (
                    (e?.Sender_UserId !== user?.UserID && e?.DealerID !== user?.DealerID && Number(e?.DealerShip) === user?.DealerID) ||
                    Number(e?.ReciverDealership) === user?.DealerID
                );
            })
            .sort((a: any, b: any) => b.Chat_ID - a.Chat_ID);
    } else {
        notificationForDBS = chatDealerShip?.filter((e: any) => {
            return (
                (e?.Sender_UserId !== user?.UserID && e?.DealerID !== user?.DealerID && Number(e?.DealerShip) === user?.DealerID) ||
                Number(e?.ReciverDealership) === user?.DealerID
            );
        });
    }
    const uniqueNotification = (notificationForDBS || []).filter((chat: any, index: number, self: any[]) => {
        if (chat) {
            const userId = chat.Sender_UserId;

            return !self.some(
                (otherChat: any) =>
                    otherChat.Sender_UserId === userId && otherChat?.Inventory_ID === chat?.Inventory_ID && otherChat.MessageDT > chat.MessageDT
            );
        }
        return false;
    });
    const fetchReciverData: any = async () => {
        const reciverResponse: any = await API.Chat.getChatRecievr({
            Inventory_ID: parameterValues?.inventryid,
            Bid_Id: parameterValues?.bidid
        });
        const chatResponse: any = await API.Chat.getChatByDealershipId({
            DealerShip: parameterValues?.DealerID,
            Inventory_ID: parameterValues?.inventryid
        });
        const ChatReciverDA = reciverResponse?.data?.data?.filter((e: any) => {
            const isDuplicate = uniqueSenderIds.has(e.DealerID);
            uniqueSenderIds.add(e.DealerID);
            return !isDuplicate && e?.RoleId === 3;
        });
        setChatDealerShip(chatResponse?.data?.data);
        setChatReciver(ChatReciverDA);
    };
    useEffect(() => {
        fetchReciverData();
    }, []);
    // const [searchText, setSearchText] = useState("");

    // function handleSearchText(event: React.ChangeEvent<HTMLInputElement>) {
    //     setSearchText(event.target.value);
    // }
    // const chatsArray = [
    //     { contactId: 2, name: "Karthik", lastMessage: "Hello", lastMessageAt: new Date(), unreadCount: 0 },
    //     { contactId: 2, name: "Gokul", lastMessage: "Hello", lastMessageAt: new Date(), unreadCount: 0 },
    //     { contactId: 2, name: "Chetan", lastMessage: "Hello", lastMessageAt: new Date(), unreadCount: 0 },
    //     { contactId: 2, name: "Faizon", lastMessage: "Hello", lastMessageAt: new Date(), unreadCount: 0 }
    // ];

    return (
        <Box
            component="div"
            sx={{ width: "40%", display: "flex", flexDirection: "column", flex: "auto", height: "80vh" }}
            // className="flex flex-col flex-auto h-full"
        >
            <Box
                // className="py-16 px-32 border-b-1"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === "light"
                            ? lighten(theme.palette.background.default, 0.4)
                            : lighten(theme.palette.background.default, 0.02),
                    py: 3,
                    px: 3,
                    borderBottom: 0
                }}
            >
                <Box component="div" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    {user && (
                        <Box
                            component="div"
                            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                            // onClick={() => setUserSidebarOpen(true)}
                            // onKeyDown={() => setUserSidebarOpen(true)}
                            role="button"
                            tabIndex={0}
                        >
                            {/* <UserAvatar className="relative" user={user} /> */}
                            <Avatar sx={{ bgcolor: "#ececec", position: "relative", height: 30, width: 30, fontWeight: "bold" }}>
                                <Typography fontWeight={700}>{user?.First_Name?.split("")?.[0]}</Typography>
                            </Avatar>
                            <Typography className="mx-16 font-medium" mx={2}>
                                {user?.First_Name ?? ""} {user?.Last_Name ?? ""}
                            </Typography>
                        </Box>
                    )}
                </Box>

                {useMemo(
                    () => (
                        <Paper
                            elevation={0}
                            sx={{
                                width: "100%",
                                display: "flex",
                                paddingX: 16,
                                paddingY: 4,
                                justifyContent: "center",
                                alignItems: "center",
                                padding: 3.2,
                                borderRadius: 15,
                                boxShadow: "none",
                                height: 5
                            }}
                            // className="flex p-4 items-center w-full px-16 py-4 border-1 h-40 rounded-full shadow-none"
                        >
                            <SearchSharpIcon fontSize="medium" />
                            <Input
                                placeholder="Search or start new chat"
                                // className="flex flex-1 px-8"
                                sx={{ display: "flex", flex: 1, px: 2 }}
                                disableUnderline
                                fullWidth
                                // value={searchText}
                                inputProps={{
                                    "aria-label": "Search"
                                }}
                                // onChange={handleSearchText}
                            />
                        </Paper>
                    ),
                    []
                )}
            </Box>

            <div>
                <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
                    {useMemo(() => {
                        // function getFilteredArray<T>(arr: T[], _searchText: string): T[] {
                        //     if (_searchText.length === 0) {
                        //         return arr;
                        //     }
                        //     return null;
                        // }

                        // const filteredContacts = getFilteredArray([...contacts], searchText);

                        // const filteredChatList = getFilteredArray([...chatListContacts], searchText);

                        // const container = {
                        //     show: {
                        //         transition: {
                        //             staggerChildren: 0.1
                        //         }
                        //     }
                        // };

                        // const item = {
                        //     hidden: { opacity: 0, y: 20 },
                        //     show: { opacity: 1, y: 0 }
                        // };

                        return (
                            <Box
                                sx={{
                                    display: "flex",
                                    background: "#fff",
                                    flexDirection: "column",
                                    flexShrink: 0,
                                    height: "80vh",
                                    overflow: "auto"
                                }}
                                // className="flex flex-col shrink-0"
                            >
                                {/* {filteredChatList.length > 0 && ( */}
                                <div>
                                    <Typography className="font-xl text-20 px-32 py-10" color="secondary.main">
                                        Chats
                                    </Typography>
                                </div>
                                {uniqueNotification?.length > 0 &&
                                    uniqueNotification.map((chat: any) => (
                                        <Box component="div">
                                            <ChatListItem item={chat} />
                                        </Box>
                                    ))}
                                {uniqueNotification?.length < 1 &&
                                    parameterValues?.year &&
                                    // chats?.length <= 1 &&
                                    chatReciver?.map(
                                        (chat: any) =>
                                            chat?.DealerID !== user?.DealerID && (
                                                <Box component="div">
                                                    <ChatListItem item={chat} />
                                                </Box>
                                            )
                                    )}
                            </Box>
                        );
                    }, [uniqueNotification, chatReciver])}
                </List>
            </div>
        </Box>
    );
}

export default MainSidebar;
